/*
 *
 *  #region Copyright (c), Crompton Greaves Consumer Electricals Ltd.
 *  Crompton R&D IoT Department Proprietary Software
 *
 *  This file is part of Crompton Smart Home SDK
 *  Copyright (c) 2024 Crompton Greaves Consumer Electricals Ltd. All rights reserved.
 *  Contact: CROMPTON DEVELOPER SUPPORT <iot.platform@crompton.co.in>
 *
 *  This software, including documentation, is protected by copyright by
 *  Crompton Greaves Consumer Electricals Ltd. All rights are reserved. Copying, including reproducing, storing,
 *  adapting or translating, any or all of this material requires the prior written consent of
 *  Crompton Greaves Consumer Electricals Ltd. This material also contains confidential information which should not
 *  be disclosed to others without the prior written consent of Crompton Greaves Consumer Electricals Ltd.
 *
 *  Filename :
 *  * Created on: <Date>
 *  Author    :
 *  * #endregion
 * /
 *
 */
/*eslint-disable*/
import React from "react";
export default function Footer() {
    const version = require('../../../package.json').version;
    const date = require('../../../package.json').date;
    return (
        <div
            className="z-[5] mx-auto flex w-full max-w-screen-sm flex-col items-center justify-between px-[20px] pb-4 lg:mb-6 lg:max-w-[100%] lg:flex-row xl:mb-2 xl:w-[1310px] xl:pb-6">
            <p className="mb-6 text-center text-sm text-gray-600 md:text-base lg:mb-0">
                <a href="https://www.crompton.co.in/" target="blank"
                   className="text-base font-medium text-gray-600 hover:text-gray-600">
                    ©{1900 + new Date().getYear()} Crompton Greaves Consumer Electricals Ltd.
                </a>
            </p>
            <ul className="flex flex-wrap items-center sm:flex-nowrap">
                <li className="mr-12">
                    <a
                        target="blank"
                        href="https://www.crompton.co.in/pages/terms-of-service"
                        className="text-sm text-gray-600 hover:text-gray-600 md:text-base lg:text-gray-600 lg:hover:text-gray-600"
                    >
                        Terms of service
                    </a>
                </li>
                <li className="mr-12">
                    <a
                        target="blank"
                        href="https://www.crompton.co.in/pages/privacy-notice"
                        className = "text-sm text-gray-600 hover:text-gray-600 md:text-base lg:text-gray-600 lg:hover:text-gray-600"
                    >
                        Privacy Notice
                    </a>
                </li>
                <li className="mr-12">
                    <a
                        target="blank"
                        href="https://www.crompton.co.in/pages/cookie-policy"
                        className = "text-sm text-gray-600 hover:text-gray-600 md:text-base lg:text-gray-600 lg:hover:text-gray-600"
                    >
                        Cookie Policy
                    </a>
                </li>
                <li className="mr-12">
                    <a

                        className="text-sm text-gray-600 hover:text-gray-600 md:text-base lg:text-gray-600 lg:hover:text-gray-600"
                    >
                        Version: {version}
                    </a>
                </li>
                <li className="mr-12">
                    <a
                        className="text-sm text-gray-600 hover:text-gray-600 md:text-base lg:text-gray-600 lg:hover:text-gray-600"
                    >
                        Last Update: {date}
                    </a>
                </li>
            </ul>
        </div>
    );
}
